import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ROLE_SLUGS } from '../../utils/auth/permissionConstants';

export default function RedirectToDashboard({ userRoleSlug }) {
  const navigate = useNavigate();
  const withWallet = useSelector(state => Boolean(state.auth.authUser?.has_active_wallet));

  useEffect(() => {
    if (withWallet) {
      navigate('/my-balance-dashboard', { replace: true });
    } else if (userRoleSlug === ROLE_SLUGS.EXEC_ADMIN) {
      navigate('/health', { replace: true });
    } else if (userRoleSlug === ROLE_SLUGS.USER) {
      // A regular user without a wallet cannot view any dashboard: the vault
      // dashboard is admin-only, and the balance dashboard needs a wallet.
      // Land them on their profile so they see the account exists and can
      // wait there for the admin to activate their wallet.
      navigate('/user-profile', { replace: true });
    } else {
      navigate('/vault-dashboard', { replace: true });
    }

  }, [navigate, withWallet, userRoleSlug]);

  return null;
}